export const SEND_FEEDBACK_MUTATION = gql`
  mutation SendFeedback($message: String!) {
    sendFeedback(message: $message)
  }
`;
